import React, { useState } from "react";

function Sign({ closePopup }) {
  const [isSignup, setIsSignup] = useState(false);
  const [password, setPassword] = useState("");
  const [retypePassword, setRetypePassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);

  const toggleForm = () => {
    setIsSignup(!isSignup);
    setErrorMessage("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSignup && password !== retypePassword) {
      setErrorMessage("Passwords do not match");
    } else {
      setErrorMessage("");
      alert(`${isSignup ? "Signup" : "Login"} successful!`);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <form
        onSubmit={handleSubmit}
        className={`transition-all duration-500 w-[320px] p-8 bg-white shadow-xl rounded-lg ${
          isSignup ? "h-[450px]" : "h-[330px]"
        }`}
      >
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-xl font-bold">
            {isSignup ? "Create an account" : "Login"}
          </h1>
          <button
            type="button"
            onClick={closePopup}
            className="text-gray-400 hover:text-gray-600"
          >
            <i className="fa fa-times text-md"></i>
          </button>
        </div>

        <div className="flex flex-col gap-5">
          {isSignup && (
            <div className="flex items-center border border-gray-300 rounded-lg shadow-sm">
              <span className="px-3 text-gray-600">
                <i className="fa fa-user"></i>
              </span>
              <input
                type="text"
                placeholder="Name"
                required
                className="flex-1 p-3 text-sm outline-none"
              />
            </div>
          )}

          <div className="flex items-center border border-gray-300 rounded-lg shadow-sm">
            <span className="px-3 text-gray-600">
              <i className="fa fa-envelope"></i>
            </span>
            <input
              type="email"
              placeholder="Email or Phone Number"
              required
              className="flex-1 p-3 text-sm outline-none"
            />
          </div>

          <div className="flex items-center border border-gray-300 rounded-lg shadow-sm relative">
            <span className="px-3 text-gray-600">
              <i className="fa fa-lock"></i>
            </span>
            <input
              type={passwordVisible ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="flex-1 p-3 text-sm outline-none"
            />
            <span
              className="absolute right-3 cursor-pointer"
              onClick={togglePasswordVisibility}
            >
              <i
                className={`fa-solid ${
                  passwordVisible ? "fa-eye-slash" : "fa-eye"
                }`}
              ></i>
            </span>
          </div>

          {isSignup && (
            <div className="flex items-center border border-gray-300 rounded-lg shadow-sm relative">
              <span className="px-3 text-gray-600">
                <i className="fa fa-key"></i>
              </span>
              <input
                type={passwordVisible ? "text" : "password"}
                placeholder="Retype Password"
                value={retypePassword}
                onChange={(e) => setRetypePassword(e.target.value)}
                required
                className="flex-1 p-3 text-sm outline-none"
              />
            </div>
          )}

          {errorMessage && <p className="text-red-500">{errorMessage}</p>}

          <button
            type="submit"
            className="bg-primary text-white py-2 rounded-lg transition-all duration-300 hover:bg-primary-dark"
          >
            {isSignup ? "Signup" : "Login"}
          </button>
        </div>

        <div className="mt-4 text-center">
          <span>
            {isSignup ? "Already have an account?" : "Don't have an account?"}
            <button
              type="button"
              onClick={toggleForm}
              className="text-primary font-bold ml-2"
            >
              {isSignup ? "Login" : "Signup"}
            </button>
          </span>
        </div>
      </form>
    </div>
  );
}

export default Sign;
